/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Switch, Redirect } from "react-router-dom";
import "../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import Login from "./pages/auth/Login";
import { ContentRoute } from "../_metronic/layout";
import ForgetPassword from "./pages/auth/ForgetPassword";

export default function AuthPage() {
    return (
        <>
            <Switch>
                <ContentRoute path="/auth/login" component={Login} />
                {/* <ContentRoute
        path="/auth/registration"
        component={Registration}
      /> */}
                <ContentRoute path="/auth/forgot-password" component={ForgetPassword} />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
            </Switch>
        </>
    );
}
